import React, { createContext, useState, useContext, useEffect } from 'react';
import { adminApi } from '../services/api';
import jwt_decode from 'jwt-decode';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pendingUsername, setPendingUsername] = useState(null);
  const [otpSent, setOtpSent] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwt_decode(token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
          localStorage.removeItem('token');
          setUser(null);
        } else {
          setUser(decoded);
        }
      } catch (error) {
        console.error('Invalid token:', error);
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      // Initial login - this will trigger OTP send
      await adminApi.login(username, password);
      setPendingUsername(username);
      setOtpSent(true);
      return true;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const verifyOtp = async (otpCode) => {
    try {
      const response = await adminApi.verifyOtp(pendingUsername, otpCode);
      const { token } = response.data;
      localStorage.setItem('token', token);
      const decoded = jwt_decode(token);
      setUser(decoded);
      setPendingUsername(null);
      setOtpSent(false);
      return true;
    } catch (error) {
      console.error('OTP verification error:', error);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setPendingUsername(null);
    setOtpSent(false);
  };

  const value = {
    user,
    login,
    logout,
    loading,
    verifyOtp,
    otpSent,
    pendingUsername,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
